<template>
  <div v-loading="loading" class="screens">
    <aside>
      <div class="list-top">
        <div class="aside-title">
          <Icon icon="zu33680" class="icon"></Icon>
          数据大屏
        </div>
        <el-button type="primary" class="add-new" @click="handleShowAddDialog">新建大屏</el-button>
      </div>
      <div class="screen-list-wrap">
        <ul v-if="screenList.length" class="screen-list">
          <li v-for="(item,i) in screenList" :key="i" class="screen-item" :class="activeIndex === i? 'active-screen' : ''" @click="activeIndex = i">
            <div class="icon-wrapper">
              <Icon icon="zu33682-6k102ald" class="icon"></Icon>
            </div>
            <div class="name">{{ item.panelName }}</div>
            <div class="points">
              <Icon icon="zu33465" class="icon"></Icon>
              <div class="points-operation">
                <div class="box">
                  <div @click="handleShowRenameDialog(item)">重命名</div>
                  <div @click="handlePanelDialog(i)">自定义地址</div>
                  <div @click="handleCopyDialog(item)">复制大屏</div>
                  <div @click="handleDel(item.panelSn)">删除</div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </aside>
    <!-- 选中大屏 -->
    <main v-if="screenList.length && activeIndex !== undefined" class="screen-selected">
      <div class="operation-bar">
        <span class="screen-name">{{ screenList[activeIndex].panelName || 'xxx大屏' }}</span>
        <span class="screen-operations">
          <span class="screen-operation-item" @click="handleViewScreen(screenList[activeIndex].panelSn)">
            <Icon icon="zu33466" class="icon"></Icon>
            <span>查看大屏</span>
          </span>
          <span class="screen-operation-item" @click="handleEditScreen(screenList[activeIndex].panelSn)">
            <Icon icon="zu33470" class="icon"></Icon>
            <span>编辑大屏</span>
          </span>
        </span>
      </div>
      <div class="screen-img-wrap">
        <div
          class="screen-img"
          :style="{
            background: `url(${screenList[activeIndex].panelThumbnail}) 50% 10%/contain no-repeat`
          }">
        </div>
      </div>
    </main>
    <!-- 无大屏 -->
    <main v-if="!screenList.length" class="no-screen">
      <div class="tip">
        <img src="https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/no-screen-tip.png" alt="">
        <span class="no-screen-tips">
          暂无大屏，
          <span class="btn" @click="handleShowAddDialog">马上创建</span>
        </span>
      </div>
    </main>

    <!-- 新增大屏 -->
    <AddScreenDialog
      v-if="addDialogShow"
      @close="addDialogShow = false" />
    <PanelSnDialog v-if="panelSnDialogShow" :screen-info="itemInfo" @close="handleClosePanel"></PanelSnDialog>
  </div>
</template>

<script>
import _ from 'lodash'
import AddScreenDialog from './components/addScreenDialog.vue'
import PanelSnDialog from './components/panelSnDialog.vue'

import {
  getScreenListApi,
  deleteScreenApi,
  renameScreenApi,
  // updatePanelSnApi,
  copyScreenApi,
} from './fetch'
export default {
  name: 'Screen',
  components: {
    AddScreenDialog,
    PanelSnDialog,
  },
  data () {
    return {
      loading: false,
      screenList: [],
      activeIndex: undefined,
      renameDialogShow: false,
      renameItem: null,
      addDialogShow: false,
      panelSnDialogShow: false,
      itemInfo: {

      },
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      try {
        const res = await getScreenListApi()
        this.screenList = res
        if (this.screenList.length) {
          this.activeIndex = 0
        }
      } catch (e) {
        this.$error(e)
      }
    },
    handleDel (id) {
      this.$confirm('确定删除该大屏吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await deleteScreenApi(id)
        this.$success('删除成功！')
        this.init()
      }).catch((e) => {
        if (e !== 'cancel') {
          this.$error(e)
        }
      })
    },
    handleShowRenameDialog (item) {
      this.$prompt('', '重命名大屏', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: item.panelName,
        inputPlaceholder: '请输入大屏名称',
        closeOnClickModal: false,
        inputValidator: (val) => {
          if (!val) {
            return '请输入'
          } else if (/^.{1,10}$/.test(val)) {
            return true
          } else {
            return '最多输入10位'
          }
        },
        inputErrorMessage: '名称格式不正确',
      }).then(async ({ value }) => {
        await renameScreenApi({
          panelName: value,
          panelSn: item.panelSn,
        })
        this.screenList = await getScreenListApi()
        this.$success('操作成功')
      }).catch(() => {

      })
    },
    handleCloseRenameDialog (refresh) {
      this.renameItem = null
      this.renameDialogShow = false
      if (refresh) {
        this.init()
      }
    },

    handlePanelDialog (index) {
      this.panelSnDialogShow = true
      this.itemInfo = _.cloneDeep(this.screenList[index])
    },
    async handleClosePanel (flag) {
      this.panelSnDialogShow = false
      this.itemInfo = null
      if (flag) {
        this.screenList = await getScreenListApi()
        this.$success('操作成功')
      }
    },

    handleCopyDialog (item) {
      this.$prompt('请填写新大屏的名称', '复制大屏', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: '',
        inputPlaceholder: '请输入大屏名称',
        closeOnClickModal: false,
        inputValidator: (val) => {
          if (!val) {
            return true
          } else if (/^.{1,10}$/.test(val)) {
            return true
          } else {
            return '最多输入10位'
          }
        },
        inputErrorMessage: '名称格式不正确',
      }).then(async ({ value }) => {
        console.log(value, item.panelSn)
        await copyScreenApi({
          panelName: value,
          copyPanelSn: item.panelSn,
        })
        this.screenList = await getScreenListApi()
        this.$success('操作成功')
      }).catch(() => {

      })
    },
    handleViewScreen (id) {
      const newPage = this.$router.resolve({ path: `/screen/view/${id}` })
      window.open(newPage.href, '_blank')
    },
    handleEditScreen (id) {
      this.$router.push({
        path: `/screen/edit/${id}`,
      })
    },
    handleShowAddDialog () {
      this.addDialogShow = true
    },
  },
}
</script>

<style lang="scss" scoped>
.screens{
  display: flex;
  color: #4E4E4E;
  aside{
    width: 220px;
    height: 100%;
    background: #f5f5f5;
    padding: 20px 0 0 20px;
    display: flex;
    flex-direction: column;
    .list-top{
      padding-bottom: 13px;
    }
    .aside-title{
      height: 24px;
      margin: 0 0 33px 23px;
      display: flex;
      font-size: 16px;
      font-weight: bold;
      color: #1C1C1C;
      .icon{
        font-size: 24px;
        margin-right: 5px;
        color: #3269FF;
      }
    }
    .add-new{
      width: 160px;
      height: 36px;
      margin-left: 10px;
    }
    .screen-list-wrap{
      height: 0;
      flex: 1;
      overflow: auto;
      .screen-list{
        margin-top: 13px;
        .screen-item{
          height: 52px;
          line-height: 52px;
          display: inline-flex;
          width: 100%;
          cursor: pointer;
          &:hover{
            background:url('https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/common/aside-bg.png') left center;
            color: #3269FF;
            .icon-wrapper>.icon{
              visibility: visible;
            }
            .points{
              visibility: visible;
            }
          }
          .icon-wrapper{
            width: 45px;
            .icon{
              visibility: hidden;
              margin-left: 25px;
            }
          }

          .name{
            display: inline-block;
            width: 110px;
            white-space: nowrap;
            /*溢出部分文字隐藏*/
            overflow: hidden;
            /*溢出部分省略号处理*/
            text-overflow: ellipsis;
          }
          .points{
            visibility: hidden;
            position: relative;
            width: 30px;
            padding: 0 10px 0 15px;
            font-size: 12px;
            &:hover{
              .points-operation{
                font-size: 14px;
                display: inline-block;
                visibility: visible;
                opacity: 1;
                transition: all 50ms ease;
              }
            }
            &-operation{
              visibility: hidden;
              position: absolute;
              width: 98px;
              height: 120px;
              top: 45px;
              right: 0;
              background: #E8E8E8;
              font-weight: 400;
              color: #4E4E4E;
              border-radius: 8px;
              opacity: 0;
              transition: all .2s ease;
              .box{
                display: flex;
                flex-direction: column;
                padding: 10px 10px;
                align-items: flex-start;
                div{
                  cursor: pointer;
                  height: 25px;
                  width: 100%;
                  line-height: 25px;
                  &:hover{
                    color: #3269FF;
                  }
                }
              }
            }
          }
        }
        .active-screen{
          background:url('https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/common/aside-bg.png') left center;
          color: #3269FF;
          .icon-wrapper{
            .icon{
              visibility: visible;
            }
          }
          .point{
            display: inline;
          }
        }
      }
    }

  }
  .screen-selected{
    flex: 1;
    width: 0;
    display: flex;
    flex-direction: column;
    .operation-bar{
      border-bottom: 1px solid #f5f5f5;
      margin: 0 40px;
      display: flex;
      justify-content: space-between;
      height: 60px;
      line-height: 60px;
      .screen-operation-item{
        padding: 0 10px;
        cursor: pointer;
        &:hover {
          color: #3269ff;
        }
        .icon {
          font-size: 20px;
          vertical-align: middle;
        }
      }
      .icon{
        font-size: 16px;
        margin-right: 5px;
      }
    }
    .screen-img-wrap{
      width: 100%;
      height: 100%;
      padding: 20px;
      .screen-img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .no-screen{
    flex: 1;
    width: 0;
    .no-screen-tips{
      margin-top: 20px;
    }
    .tip{
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      font-weight: bold;
      .btn{
        color: #3269FF;
        cursor: pointer;
      }
    }
  }
}
</style>
